import ratesService from '@common/services/rates.service';

export default {
    setBet({ commit }, betData) {
        commit('setBet', betData);
    },
    setBetDataByKey({ commit }, { key, value }) {
        commit('setBetDataByKey', { key, value });
    },
    setRates({ commit }, rates) {
        commit('setRates', rates);
    },
    async fetchRates(context) {
        try {
            const res = await ratesService.getRates();
            context.dispatch('setRates', res.data.rows);
        } catch (error) {
            console.error(error);
            context.dispatch('setRates', null);
        }
    },
};
